// Persistent header entry point for the win-back FREE unlimited hour. Stays in
// the header for the whole session so a user who dismissed the welcome-back
// popup can still claim. Gold/amber (free reward) to read distinctly from the
// red paid "Bonus" teaser. Purely presentational — onClick re-opens the
// centralized reengagement modal in _app.tsx. Markup mirrors UnlimitedBonusTeaser;
// keep the two in step if either is resized.
export default function UnlimitedReengagementTeaser({
  onClick,
}: {
  onClick?: () => void;
}) {
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={() => onClick?.()}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick?.();
        }
      }}
      aria-label="Claim your free unlimited hour"
      className="flex flex-col items-center cursor-pointer hover:scale-105 transform transition-transform duration-300"
    >
      {/* Geometry mirrors UnlimitedBonusTeaser exactly — only the palette differs.
          Sized to draw ~18px of ink so it matches the bell / gift / coin beside it;
          the box was 32x22 (full width of its container) and read as a wide slab.
          The old -translate-y-[6px] nudge is gone: it was hand-tuned against that
          oversized box and now pushes the icon out of line. */}
      <div className="relative flex h-9 items-center justify-center">
        <div className="relative h-9 w-[17px]" aria-hidden>
          {/* bow — rests on the box's top edge */}
          <div className="absolute left-1/2 top-[7px] z-10 flex -translate-x-1/2 gap-[1px]">
            <span className="h-[4px] w-[4px] -rotate-[20deg] rounded-full bg-gradient-to-br from-amber-300 to-amber-500" />
            <span className="h-[4px] w-[4px] rotate-[20deg] rounded-full bg-gradient-to-bl from-amber-300 to-amber-500" />
          </div>
          {/* box + vertical ribbon, centered on the row line. Glow cut from 8px to
              3px: a solid filled shape already reads heavier than the hollow line
              icons beside it, and an 8px halo added ~16px of apparent width. */}
          <div className="absolute inset-x-0 top-1/2 h-[14px] -translate-y-1/2 overflow-hidden rounded-[3px]
                          bg-gradient-to-b from-neutral-700 via-neutral-900 to-black
                          ring-1 ring-amber-400/50 shadow-[0_0_3px_rgba(251,191,36,0.4)]">
            <span className="absolute inset-y-0 left-1/2 w-[3px] -translate-x-1/2 bg-gradient-to-b from-amber-300 to-amber-500" />
          </div>
        </div>
        {/* attention dot — anchored to the box's top-right */}
        <span className="absolute right-0 top-[6px] h-1.5 w-1.5 rounded-full bg-amber-300 ring-2 ring-headerBackground animate-pulse" />
      </div>
      <span className="hidden md:block text-amber-300 text-[0.5rem] -mt-0.5 font-semibold">
        Free hr
      </span>
    </div>
  );
}
